module.exports = __webpack_public_path__ + "img/CONTISEND.aca995b2.png";